import { PagarResponse } from "./pagarResponse";

export const PAGAMENTO_PREMIACAO = "PAGAMENTO_PREMIACAO";
export const PAGAMENTO_PREMIACAO_ERROR = "PAGAMENTO_PREMIACAO_ERROR";

export interface PremiacaoError {
  item: PagarResponse;
  erro: string;
}

export interface PremiacaoState {
  Errors: PremiacaoError[];
}

export interface PremiacaoActionTypes {
  type: string;
  payload?: PremiacaoError;
}
